export const PREVIEW_MAX_ROWS = 150;

/** Minimal CSV/TSV parser that handles quoted fields and escaped quotes. */
export const parseDelimitedText = (
  text: string,
  maxRows: number = PREVIEW_MAX_ROWS
): string[][] => {
  const firstLine = text.split(/\r?\n/, 1)[0] ?? "";
  const commaCount = (firstLine.match(/,/g) || []).length;
  const tabCount = (firstLine.match(/\t/g) || []).length;
  const delimiter = tabCount > commaCount ? "\t" : ",";

  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const next = text[i + 1];

    if (inQuotes) {
      if (char === '"' && next === '"') {
        cell += '"';
        i++;
      } else if (char === '"') {
        inQuotes = false;
      } else {
        cell += char;
      }
      continue;
    }

    if (char === '"') {
      inQuotes = true;
    } else if (char === delimiter) {
      row.push(cell);
      cell = "";
    } else if (char === "\n") {
      row.push(cell);
      if (row.some((c) => c.trim().length > 0)) {
        rows.push(row);
      }
      row = [];
      cell = "";
      if (rows.length >= maxRows) {
        break;
      }
    } else if (char === "\r") {
      // ignore; handled with \n
    } else {
      cell += char;
    }
  }

  if (rows.length < maxRows && (cell.length || row.length)) {
    row.push(cell);
    if (row.some((c) => c.trim().length > 0)) {
      rows.push(row);
    }
  }

  return rows;
};

export const isPreviewableArchiveFile = (filename: string): boolean => {
  const lower = filename.toLowerCase();
  return (
    lower.endsWith(".csv") ||
    lower.endsWith(".tsv") ||
    lower.endsWith(".txt") ||
    lower.endsWith(".log") ||
    lower.endsWith(".json")
  );
};
